import { CalendarEventFormFields, CalendarEventRef } from '@griply/types';
import { CreateCalendarEventInitial } from '@griply/utils';
import { createContext } from 'react';
import { ExternalEventDragRequest } from 'shared/lib/full-calendar';

// viewport coordinates the popup floats from — captured from the clicked event's rect
export type EventPopupAnchor = { top: number; left: number };

export type OpenEditEventOptions = {
  anchor: EventPopupAnchor;
  // everything the clicked grid event already knows, so the popup paints before the fetch
  seed: CalendarEventFormFields;
  // the event at the provider; absent on responses from an older backend
  url?: string;
};

export type EventFormContextProps = {
  onCreateEvent: (
    initial: CreateCalendarEventInitial,
    anchor: EventPopupAnchor,
  ) => void;
  onEditEvent: (
    target: CalendarEventRef,
    options: OpenEditEventOptions,
  ) => void;
  // `revert` undoes FullCalendar's own interactive move — the only way to put a deferred
  // (recurring) drag back without waiting on a refetch
  onDragEvent: (request: ExternalEventDragRequest, revert: () => void) => void;
};

export const EventFormContext = createContext<EventFormContextProps>({
  onCreateEvent: () => {},
  onEditEvent: () => {},
  onDragEvent: () => {},
});
